// extracted by mini-css-extract-plugin
export var chevron = "_j2-2";
export var dropdownItems = "_j2-0";
export var item = "_j2-1";